var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.roomType)?_c('span',[_vm._v(_vm._s(_vm.$t('common.capacity'))+_vm._s(_vm.maxOccupancy)+_vm._s(_vm.$t('common.firstName'))+" "+_vm._s(_vm.bedShareText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }